import { useEffect, useRef } from "react";
import { Map } from "leaflet";
import { useTranslation } from "react-i18next";
import { useRouting } from "stores/routingStore/RoutingContext";
import { getTrackByUUID } from "utils/api/getTrackByUUID";
import { getQueryTrackID } from "utils/getQueryParam";
import { parseTrackFromAPI } from "utils/helpers/trackParser/trackParser";
import { useGenericModals } from "./useGenericModals";

/**
 * Opens the track of a shared link (`?trkid=<uuid>`) in the editor once the map is there. It's tried once: when it
 * fails, the user is told once, not again whenever e.g. the language changes.
 */
export const useOpenSharedTrack = (map: Map | null | undefined) => {
  const trackIdRef = useRef(getQueryTrackID());
  const { setEditedTrack } = useRouting();
  const { openErrorModal } = useGenericModals();
  const { t } = useTranslation();

  useEffect(() => {
    const trackId = trackIdRef.current;
    if (!map || !trackId) return;
    trackIdRef.current = null;

    getTrackByUUID(trackId)
      .then((rawTrack) =>
        setEditedTrack(parseTrackFromAPI(rawTrack), map, "shared")
      )
      .catch(() =>
        openErrorModal({
          title: t("generic.error_title"),
          text: t("errors.cannot_open_track_by_id.text"),
        })
      );
  }, [map, openErrorModal, setEditedTrack, t]);
};
